/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Grid } from '@coursera/cds-core';

import type { EntWebsitePlanCardsColumnFragment } from 'bundles/ent-website/__generated__/contentfulTypes';
import EntWebsitePlanCard from 'bundles/ent-website/components//EntWebsitePlanCard';

type Props = { content: EntWebsitePlanCardsColumnFragment };

export const EntWebsitePlanCards = ({ content }: Props) => {
  return (
    <Grid container direction="row">
      {content?.planCardsCollection?.items?.map((card) => (
        <EntWebsitePlanCard key={card?.title} card={card} />
      ))}
    </Grid>
  );
};

export default React.memo(EntWebsitePlanCards);
